/* eslint-disable filenames/match-exported */
//import pages component
import Feed from "../../scenes/Feed";
import PostDetailed from "../../scenes/PostDetailed";
import OthersProfile from "../../scenes/OthersProfile";
import Aboutus from "../../scenes/Aboutus";
import CaseFormContainer from "../../scenes/CaseFormContainer";
import LoginPage from "../../scenes/LoginPage";
import ContentPolicy from "../../scenes/Sections/ContentPolicy";
import PrivacyPolicy from "../../scenes/Sections/PrivacyPolicy";
import TOS from "../../scenes/Sections/TermsOfUse";
import Appendix from "../../scenes/Sections/TOSAppendix";
import NotificationsPage from "../../scenes/Notifications";
import EditProfilePage from "../../scenes/EditProfilePage";
import SearchPage from "../../scenes/Search";
import SignupPage from "../../scenes/SignupPage";
import SigninPage from "../../scenes/SigninPage";
import ForgetPasswordPage from "../../scenes/ForgetPasswordPage";
import AuthActionPage from "../../scenes/AuthActionPage";
import PreferencesPage from "../../scenes/PreferencesPage";
import CollectionPage from "../../scenes/CollectionPage";

//import pages layous
import LandingLayout from "../Layouts/LandingLayout";
import BlankLayout from "../Layouts/BlankLayout";
import MainLayoutNoNavbar from "../Layouts/MainLayoutNoNavbar";

import { RouteAccessState } from "../../constants";
import {
  HomeRouteSaga,
  PostSlugRouteSaga,
  PostIdRouteSaga,
  CollectionRouteSaga,
  ProfileIdRouteSaga,
  ProfileUsernameRouteSaga, 
  ProfileIdCollectionsRouteSaga,
  ProfileUsernameCollectionsRouteSaga,
  ProfileIdFollowersRouteSaga,
  ProfileUsernameFollowersRouteSaga,
  ProfileIdFollowingRouteSaga,
  ProfileUsernameFollowingRouteSaga,
  SearchRouteSaga,
} from "../../sagas/server";
//@NOTE: title key is used for analytics tracking
const routes = [
  {
    path: "/",
    exact: true,
    component: Feed,
    title: "Home",
    access: RouteAccessState.loggedInOnly,
    saga: HomeRouteSaga,
  },

  {
    path: "/category/:categoryName",
    exact: true,
    component: Feed,
    title: "Category",
    access: RouteAccessState.loggedInOnly,
  },

  {
    path: "/about",
    component: Aboutus,
    title: "AboutPage",
    access: RouteAccessState.public,
    layout: LandingLayout,
  },

  {
    path: "/newcase",
    component: CaseFormContainer,
    title: "NewCase",
    layout: MainLayoutNoNavbar,
    access: RouteAccessState.loggedInOnly,
  },
  {
    path: "/search",
    component: SearchPage,
    title: "Search",
    access: RouteAccessState.public,
    saga: SearchRouteSaga,
  },
  {
    path: "/posts/:caseid/edit",
    component: CaseFormContainer,
    title: "EditCase",
    layout: MainLayoutNoNavbar,
    access: RouteAccessState.loggedInOnly,
  },
  {
    path: "/admin/posts/:caseid/edit",
    component: CaseFormContainer,
    title: "Edit Case",
    layout: MainLayoutNoNavbar,
    access: RouteAccessState.AdminOnly,
  },
  {
    path: "/case/:slug/edit",
    component: CaseFormContainer,
    title: "EditCase",
    layout: MainLayoutNoNavbar,
    access: RouteAccessState.loggedInOnly,
  },
  {
    path: "/admin/case/:slug/edit",
    component: CaseFormContainer,
    title: "Edit Case",
    layout: MainLayoutNoNavbar,
    access: RouteAccessState.AdminOnly,
  },
  {
    "/followers": {
      title: "Profile followers",
      saga: ProfileIdFollowersRouteSaga,
    },
    "/following": {
      title: "Profile following",
      saga: ProfileIdFollowingRouteSaga,
    },
    "/collections": {
      title: "Profile collections",
      saga: ProfileIdCollectionsRouteSaga,
    },
    path: "/profile/:id",
    component: OthersProfile,
    title: "Profile",
    access: RouteAccessState.public,
    saga: ProfileIdRouteSaga,
  },
  {
    "/followers": {
      title: "Profile followers",
      saga: ProfileUsernameFollowersRouteSaga,
    },
    "/following": {
      title: "Profile followers",
      saga: ProfileUsernameFollowingRouteSaga,
    },
    "/collections": {
      title: "Profile collections",
      saga: ProfileUsernameCollectionsRouteSaga,
    },
    path: "/user/:username",
    component: OthersProfile,
    access: RouteAccessState.public,
    title: "UserProfile",
    saga: ProfileUsernameRouteSaga,
  },
  {
    path: "/posts/:id",
    component: PostDetailed,
    access: RouteAccessState.public,
    title: "Post",
    saga: PostIdRouteSaga,
  },
  {
    path: "/case/:slug",
    component: PostDetailed,
    access: RouteAccessState.public,
    title: "Post",
    saga: PostSlugRouteSaga,
  },
  {
    path: "/login",
    component: LoginPage,
    layout: BlankLayout,
    access: RouteAccessState.public,
    title: "AutomaticLoginPage",
  },
  {
    path: "/sections/content-policy",
    component: ContentPolicy,
    layout: MainLayoutNoNavbar,
    access: RouteAccessState.public,
    title: "ContentPolicy",
  },
  {
    path: "/sections/privacy",
    component: PrivacyPolicy,
    layout: MainLayoutNoNavbar,
    access: RouteAccessState.public,
    title: "PrivacyPolicy",
  },
  {
    path: "/sections/tos",
    component: TOS,
    layout: MainLayoutNoNavbar,
    access: RouteAccessState.public,
    title: "TermsOfUse",
  },
  {
    path: "/sections/tos-appendix",
    component: Appendix,
    layout: MainLayoutNoNavbar,
    access: RouteAccessState.public,
    title: "TermsOfUseAppendix",
  },
  {
    path: "/notifications",
    component: NotificationsPage,
    title: "Notifications",
    access: RouteAccessState.loggedInOnly,
  },
  {
    path: "/editprofile",
    component: EditProfilePage,
    title: "EditProfilePage",
    access: RouteAccessState.loggedInOnly,
  },
  {
    path: "/signup",
    component: SignupPage,
    title: "Signup page",
    access: RouteAccessState.loggedOutOnly,
  },
  {
    path: "/signin",
    component: SigninPage,
    title: "Signin",
    access: RouteAccessState.loggedOutOnly,
  },
  {
    path: "/forgotpassword",
    component: ForgetPasswordPage,
    title: "forgetPassword",
    access: RouteAccessState.loggedOutOnly,
  },
  {
    path: "/auth-action",
    component: AuthActionPage,
    access: RouteAccessState.public,
    title: "handleAuth",
  },
  {
    path: "/preferences",
    component: PreferencesPage,
    access: RouteAccessState.loggedInOnly,
    title: "preferences",
  },
  {
    path: "/collections/:id/:slug",
    component: CollectionPage,
    access: RouteAccessState.public,
    title: "collection",
    saga: CollectionRouteSaga,
  },
  {
    path: "/collections/:id",
    component: CollectionPage,
    access: RouteAccessState.public,
    title: "collection",
    saga: CollectionRouteSaga,
  },
];

//routes formatted for redux little router
export const reduxRoutes = routes.reduce((acc, curr) => ({ ...acc, [curr.path]: curr }), {});
export default routes;



// WEBPACK FOOTER //
// ./src/util/Router/routes.js